/* tslint:disable */
/* eslint-disable */
/**
 * customer crage-reserveのタイトル
 * フロントエンド開発に必要なデータ定義場所
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export * from "./api";
export * from "./configuration";

